export default {"src":"/_next/static/media/venisoniconblack.1f0023e8.svg","height":64,"width":64};